import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../main-page.service';
import { ConnectorManagmentComponent } from '../connector-managment/connector-managment.component';
import { SystemModel } from '../../../../models/dictionaries/system.model';
import { CorosiveProtectionModel } from '../../../../models/dictionaries/corosive-protection.model';
import { UniversalConnectorModel, ConnectorType } from '../../../../models/parts/universal-connector.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';


declare var $: any;


@Component({
  selector: 'app-connector-grid',
  template: `<!-- <div [hidden]="isConnectorHidden">
    <hc-data-grid id="mainGrid" (onAddClick)="addConnector()" [data]="myArray" [select]="false" [headers]="headers" [subheader]="true" [displayedColumns]="displayedColumns" (onEditClick)="onConnectorClick($event)">
    </hc-data-grid>
</div> -->

<!-- Edit Modal -->
<div class="modal" id="addConnectorModal">
    <div class="modal-dialog">
            <div class="form">
                    <form class="form-group" [formGroup]="formGroup">
                        <div class="modal-content">
        
                            <!-- Modal Header -->
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
        
                            <!-- Modal body -->
                            <div class="modal-body display-flex">
                                <div>
                                    <div>
                                        <div class="display-flex">
                                            <span class="modal-label">Article no:</span>
                                            <input type="number" formControlName="articleNumber" [(ngModel)]="templateConnector.articleNumber">
                                        </div>
                                        <div class="display-flex">
                                            <span class="modal-label">Name:</span>
                                            <input type="text" [(ngModel)]="templateConnector.name" formControlName="name">
                                        </div>
                                        <div class="display-flex">
                                            <span class="modal-label">Description:</span>
                                            <input type="text" [(ngModel)]="templateConnector.description" formControlName="description">
                                        </div>
                                        <div class="display-flex">
                                            <span class="modal-label">{{'Graphical analysis mode' | translate}}:</span>
                                            <select name="connectorTypeSelect" class="selectHeight" [(ngModel)]="templateConnector.connectorUsageType" formControlName="connectorUsageType">
                                                <option *ngFor="let connectorType of connectorTypeArray | sortByName" [ngValue]="connectorType.code">{{connectorType.code | translate}}</option>
                                                <!-- <option *ngFor="let connectorType of connectorTypeArray" [ngValue]="connectorType.code">{{connectorType.value}}</option> -->
                                            </select>
                                        </div>
                                        <div class="display-flex">
                                            <span class="modal-label">System:</span>
                                            <select name="systemSelect" class="selectHeight" [(ngModel)]="templateConnector.system" formControlName="system">
                                                <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                                            </select>
                                        </div>
                                        <div class="display-flex">
                                            <span class="modal-label">Corrosion protection:</span>
                                            <select name="corrProtSelect" class="selectHeight" formControlName="corrosionProtection" [(ngModel)]="templateConnector.corrosionProtection">
                                                <option *ngFor="let corrosionProtection of corrosionProtectionsArray | sortByName" [ngValue]="corrosionProtection.name">{{corrosionProtection.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                            <!-- Modal footer -->
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewConnector()">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
    </div>
</div>

<div class="input-effect">
    <input id="searchInput" class="effect1 search-input" type="text" placeholder="" (keyup)="searchInGridData()">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addConnectorModal"  (click)="prepareCreate()">Create</button>

<div class="table-wrapper">
    <div class="table-scroll">
        <table>
            <tr>
                <th *ngFor="let header of headers">{{header}}</th>
            </tr>
            <tr *ngFor="let connector of connectorGridData,let row_no = index" (click)="onRowClick(row_no,connector._id)" style="cursor:pointer" [class.highlighted]="connector._id === selectedRowId">
                <td class="column-width">{{connector.articleNumber}}</td>
                <td class="column-width">{{connector.name}}</td>
            </tr>
        </table>
    </div>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:168px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}.highlighted{background-color:#534f53!important;color:#fff}`]
})
export class ConnectorGridComponent implements OnInit {
  @Input() connectorComponent: ConnectorManagmentComponent;
  isConnectorHidden = true;
  connectorGridData: UniversalConnectorModel[] = [];
  connectorGridDataOrigin: UniversalConnectorModel[] = [];
  templateConnector = new UniversalConnectorModel(ConnectorType.Connector);
  public selectedRowId;
  public systemsArray: SystemModel[] = [];
  public corrosionProtectionsArray: CorosiveProtectionModel[] = [];
  public formGroup: FormGroup;
  public connectorTypeArray: any[] = [];

  headers: string[] = ['Article no.', 'Name'];
  constructor(private mainPageService: MainPageService) {
    this.connectorTypeArray = this.mainPageService.getConnectorTypeArray();
  }

  public ngOnInit(): void {
    this.loadData();
    // this.mainPageService.mysubject.subscribe( (value) => {
    //   this.updateConnectorInDb(value);
    //   this.connectorGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
    // });
    this.mainPageService.deleteUniversalConnectorSubject.subscribe( (value) => {
      this.connectorGridData = this.connectorGridData.filter(x => x._id !== value);
      this.connectorGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
    });
    this.createForm();
  }


  loadData(): void {
    this.mainPageService.loadAllSystems().subscribe((response) => {
      this.systemsArray = response;
    });
    this.mainPageService.loadAllCorosionProtections().subscribe((response) => {
      this.corrosionProtectionsArray = response;
    });
    this.mainPageService.loadSpecificConnectors(ConnectorType.Connector).subscribe((response) => {
      this.connectorGridData = response;
      this.connectorGridDataOrigin = response;
      this.connectorGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
      this.connectorGridDataOrigin.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
    });
   }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isConnectorHidden = !this.isConnectorHidden;
  }

  onConnectorClick(sender) {
    this.connectorComponent.showConnector(sender);
  }

  onRowClick(row, id) {
    this.selectedRowId = id;
    this.connectorComponent.showConnector(this.connectorGridData[row]);
  }

  updateConnectorInDb(id) {
    let dataToSend;
    let preparedData;
    for (const item of this.connectorGridData) {
      if (item._id === id) {
        dataToSend = item;
        break;
      }
    }
    for (const item of this.connectorGridData) {
      if (item._id === id) {
         preparedData = item;
        break;
      }
    }
    preparedData.articleNumber = dataToSend.articleNumber;
    preparedData.description = dataToSend.description;
    preparedData.name = dataToSend.name;
    this.mainPageService.updateUniversalConnectorInDb(JSON.stringify(preparedData)).subscribe(() => { });
    this.connectorGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
  }

  saveNewConnector() {
    this.mainPageService.addNewUniversalConnectorIntoDb(JSON.stringify(this.templateConnector)).subscribe((response) => {
      this.templateConnector._id = response;
      this.connectorGridData.push(this.templateConnector);
      this.templateConnector = new UniversalConnectorModel(ConnectorType.Connector);
      this.connectorGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
    });
  }

  searchInGridData() {
    const inputValue = (<HTMLInputElement>document.getElementById('searchInput')).value;
    this.connectorGridData = this.connectorGridDataOrigin;
    if ( inputValue !== '') {
      this.connectorGridData  = this.connectorGridData.filter(x => x.name.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
      || (x.articleNumber.toString().indexOf(inputValue) >= 0));
    }
  }

  public prepareCreate() {
    this.templateConnector = new UniversalConnectorModel(ConnectorType.Connector);
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.templateConnector.name, Validators.required),
      articleNumber: new FormControl(this.templateConnector.articleNumber),
      description: new FormControl(this.templateConnector.description),
      system: new FormControl(this.templateConnector.system, Validators.required),
      corrosionProtection: new FormControl(this.templateConnector.corrosionProtection, Validators.required),
      connectorUsageType: new FormControl(this.templateConnector.connectorUsageType, Validators.required),
    });
  }

}
